import CustomColumnContainer, {
  CustomColumnProps
} from './custom-column-container';

interface CustomColumnVideoPlatformProps extends CustomColumnProps {
  id?: string;
  videoId: string;
  type: 'youtube' | 'vimeo';
}

const CustomColumnVideoPlatform = ({
  type,
  videoId,
  ...props
}: CustomColumnVideoPlatformProps) => {
  return (
    <CustomColumnContainer
      columnClass={props?.columnClass}
      containerClass={props?.containerClass}>
      {videoId && (
        <iframe
          src={
            type === 'youtube'
              ? `https://www.youtube.com/embed/${videoId}`
              : `https://player.vimeo.com/video/${videoId}`
          }
          width={500}
          height={250}
          referrerPolicy={'strict-origin-when-cross-origin'}
          allow={
            'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share'
          }
          allowFullScreen
        />
      )}
    </CustomColumnContainer>
  );
};

export default CustomColumnVideoPlatform;
